import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const PIXEL_ID = '1079628221544841';
const PRODUCTION_HOSTS = ['proptick.in', 'www.proptick.in'];

function isProduction() {
  return PRODUCTION_HOSTS.includes(window.location.hostname);
}

export default function MetaPixel() {
  const location = useLocation();
  const initialized = useRef(false);
  const lastPath = useRef(null);

  // Initialize pixel + fire first PageView
  useEffect(() => {
    if (!isProduction()) return;
    if (window.fbq) return;

    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');

    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
    lastPath.current = location.pathname;
    initialized.current = true;
  }, []);

  // Fire PageView on client-side route changes only
  useEffect(() => {
    if (!initialized.current) return;
    if (!window.fbq) return;
    if (location.pathname === lastPath.current) return;
    lastPath.current = location.pathname;
    window.fbq('track', 'PageView');
  }, [location.pathname]);

  return null;
}
